import axios from "axios";
import moment from "moment";
import IDuser from "../../../common/mookup/iduser";
import jwt_decode from "jwt-decode";
import user from "../../../common/mookup/mokup_ListaUser";
import { logOut } from "../../../common/utils";

export default class DetailUserService {
  getDetailUtente(IdUser, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    //vediamo quale id viene stampato
    // onSuccess(IDuser);

    var objUser = JSON.parse(sessionStorage.getItem("user"));
    // onSuccess(user.id_anagrafica_operatore)
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
        .get(
          host + "/api/v1/user/find/" + IdUser,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore " + error);
          onSuccess(""); //mokup per il rendere di dati fittizzi in base al id
        }
      );
  }

  getListUtenteLicenza(IdUser, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/licenza/find/" + IdUser, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

  getListUtenteRotolini(IdUser, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/api/v1/rotolini/find/" + IdUser, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

  saveRotolino(IdUser,jsonRotolino, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(host + "/api/v1/rotolini/save/" + IdUser, jsonRotolino, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }


  deleteUser(jsonUser, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // console.log(jsonUser);
    axios
      .post(host + "/api/v1/user/",jsonUser ,configHeaders )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

  resetPassword(idUser,password, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .patch(host + "/api/v1/user/resetpassword/" + idUser, password, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore  " + error
          );
          onSuccess([]);
        }
      );
  }

  editUser(utente, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .put(host + "/api/v1/user/save", utente, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

  deleteLicenza(idLicenza, licenza,onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    // console.log(licenza);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(host + "/api/v1/licenza/delete/" + idLicenza, licenza, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log(
            "errore " + error
          );
          onSuccess([]);
        }
      );
  }

}
